import React from 'react';

import { StyledError } from '../FormGroup/styled';

import { StyledTimeInput, StyledIcon } from './styled';

const TimeInput = React.forwardRef(
  ({ size = 'large', icon, error, errormessage, 'data-cy': dataCy, ...props }, ref) => {
    return (
      <>
        <StyledTimeInput
          {...props}
          data-cy={dataCy}
          haserror={error ? 1 : 0}
          size={size}
          ref={ref}
          value={props.value || ''}
        />
        {icon && <StyledIcon src={icon} inputSize={size} />}
        <StyledError>
          <p>{error && errormessage}</p>
        </StyledError>
      </>
    );
  },
);

export { TimeInput };
